import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export function MemberGiftsReport() {
  const [data, setData] = useState(null);
  const [exporting, setExporting] = useState(false);
  useEffect(() => { api.get("/souvenirs/gifts/report").then((r) => setData(r.data)).catch(() => setData({ rows: [], problems: [] })); }, []);
  const exportXlsx = async () => {
    setExporting(true);
    try {
      const res = await api.get("/souvenirs/gifts/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url; a.download = "souvenirs_given_to_members.xlsx"; document.body.appendChild(a); a.click(); a.remove();
    } catch { toast.error("Export failed"); }
    finally { setExporting(false); }
  };
  if (!data) return <p className="text-sm text-muted-foreground">Loading…</p>;
  return (
    <div className="space-y-5" data-testid="member-gifts-report">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Souvenirs Facility Representatives and Chapter Secretaries have handed to members, and whether members confirmed receipt.</p>
        <Button variant="outline" className="gap-2" onClick={exportXlsx} disabled={exporting} data-testid="member-gifts-export"><DownloadSimple size={16} weight="bold" /> Export</Button>
      </div>
      <Card className="overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Facility / Chapter</TableHead><TableHead>Region</TableHead><TableHead>Members</TableHead><TableHead>T-shirts</TableHead><TableHead>Cloth</TableHead><TableHead>Received</TableHead><TableHead>Awaiting</TableHead><TableHead>Problems</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.rows.map((r) => (
              <TableRow key={r.label} data-testid={`member-gifts-row-${r.label}`}>
                <TableCell className="font-medium">{r.label}</TableCell><TableCell>{r.region || "—"}</TableCell><TableCell>{r.members}</TableCell>
                <TableCell>{r.tshirts}</TableCell><TableCell>{r.cloth}</TableCell>
                <TableCell className="text-success font-medium">{r.received}</TableCell><TableCell>{r.pending}</TableCell>
                <TableCell className={r.problem ? "text-destructive font-medium" : ""}>{r.problem}</TableCell>
              </TableRow>
            ))}
            {!data.rows.length && <TableRow><TableCell colSpan={8} className="text-center text-sm text-muted-foreground py-8">No souvenirs have been given to members yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
      {data.problems.length > 0 && (
        <Card className="p-5 border-destructive/30" data-testid="member-gifts-problems">
          <h3 className="font-display text-lg font-bold">Problems reported by members</h3>
          <ul className="mt-3 space-y-2 text-sm">
            {data.problems.map((p) => <li key={p.id}><span className="font-medium">{p.member_name}</span> ({p.pool_label}): {p.member_note}</li>)}
          </ul>
        </Card>
      )}
    </div>
  );
}
